<template></template>

<script>
import { useMenuStore } from "@/stores/menuStore";

export default {
  name: "UserDetail",
  setup() {
    const menuStore = useMenuStore();
    return { menuStore };
  },
  mounted() {
    this.menuStore.setBackActive(true);
  },
};
</script>
